import { State, Action, StateContext, Actions, ofActionSuccessful } from '@ngxs/store';
import { GetAllResource, GetCRMStatus, StoreUserProfile } from './app.actions';
import { Injectable } from '@angular/core';
import { Dispatcher } from './base/dispatcher';
import { LocalStorageService, SessionStorageService } from 'ngx-webstorage';
import { NotificationService } from '../modules/users/users.service';
import { EventManager } from '../core';
import { AppsService } from '../shared/services/apps.service';
declare let $: any;
export interface AppStateModel {
    userProfile: any;
    dataAll: any;
    products: any[];
    dataSources: any[];
    thirdApps: any[];
    issuers: any[];
    sponsorOrgs: any[];
    provinces: any[];
    crmStatuses: any[];
    broadcastHistoryStatus: any[];
    subjectTypeNewFeed: any[];
    productAssetTypes: any[];
    topHoldingTypes: any[];
    articleStatus: any[];
    partnerCorpTypes: any[];
    quizTypes: any[];
}

export function initAppState(): AppStateModel {
    return {
        userProfile: undefined,
        products: [],
        issuers: [],
        provinces: []
    } as AppStateModel;
}

@State<AppStateModel>({
    name: 'App',
    defaults: initAppState()
})
@Injectable()
export class AppState {

    constructor(
        private actions$: Actions,
        private dispatcher: Dispatcher,
        private userService: NotificationService,
        private appsService: AppsService,
        private localStorage$: LocalStorageService,
        private sessionStorage$: SessionStorageService,
        public eventManger: EventManager,
    ) {}

    @Action(GetAllResource)
    GetAllResource(ctx: StateContext<AppStateModel>, action: GetAllResource) {
       return this.userService.getAllResource({})
       .subscribe((res: any) => {
        const data = res.body.data || {};
        const issuers = (data.issuers || []).map((item) => {
            item.id = item.userId;
            return item;
        });
        const products = (data.products || []).map((product) => {
            product.textSearch = `${product.shortName} - ${product.code}`;
            return product;
        });  
        const provinces = data.provinces || [];
        const sponsorOrgs = (data.sponsorOrgList || []);
        const crmStatuses = data.crmStatus || [];
        const broadcastHistoryStatus = data.broadcastHistoryStatus || [];
        const subjectTypeNewFeed = data.subjectTypeNewFeed || [];
        const productAssetTypes = data.productAssetTypes || [];
        const topHoldingTypes = data.topHoldingTypes || [];
        const articleStatus = data.articleStatus || [];
        const partnerCorpTypes = data.partnerCorpTypes || [];
        const quizTypes = data.quizGameTypes || [];
        const dataSources = data.dataSources || [];
        const thirdApps = data.thirdApps || [];
        ctx.patchState({
            dataAll: data,
            issuers,
            sponsorOrgs,
            dataSources,
            thirdApps,
            products,
            provinces,
            broadcastHistoryStatus,
            subjectTypeNewFeed,
            productAssetTypes,
            crmStatuses,
            topHoldingTypes,
            articleStatus,
            partnerCorpTypes,
            quizTypes,
        });
       })
    }
    @Action(GetCRMStatus)
    GetCRMStatus(ctx: StateContext<AppStateModel>, action: GetCRMStatus) {
        const crmStatuses = Object.assign([], ctx.getState().crmStatuses) || [];
        if (crmStatuses.length) {
            return;
        }
        return this.appsService.queryStatusCRM({})
        .subscribe((res: any) => {
            const status = (res.body.data || {}). list || [];
            ctx.patchState({
                crmStatuses: status,
            });
        })
    }
    @Action(StoreUserProfile)
    StoreUserProfile(ctx: StateContext<AppStateModel>, action: StoreUserProfile) {
        const userProfile = action.payload;
        ctx.patchState({
            userProfile
        });
    }
}
